import Button from "@/components/Button";
import { useLectureItemVideo } from "../hooks/useLectureItemsVideo";
import { useParams } from "react-router-dom";

import { Spinner } from "@nextui-org/react";

function VideoView({ name, onCloseModal, videoId }) {
  const { courseId, lectureId } = useParams();

  const { lectureVideo, isPending } = useLectureItemVideo({
    courseId,
    lectureId,
    videoId,
  });

  if (isPending) return <Spinner />;

  return (
    <div>
      <p className="py-3 text-xl text-blue-color-primary">
        عنوان الفيديو: <span className="text-gray-600">{name}</span>
      </p>
      { lectureVideo?.data?.attributes?.provider === "youtube" ? (
          <iframe
            src={lectureVideo?.data?.attributes?.iframe}
            width="560"
            height="315"
            allow="accelerometer; autoplay; clipboard-write;
                    encrypted-media; gyroscope; picture-in-picture;fullscreen"
            className="py-5 "
          ></iframe>
      ) : (
          <div
            style={{ contain: "layout" }}
            className="w-full h-full aspect-video [&>iframe]:w-full [&>iframe]:h-full [&>iframe]:aspect-video mb-1"
            dangerouslySetInnerHTML={{ __html: lectureVideo?.data?.attributes?.videoInfo?.embed_html }}
          />
      ) }

      <Button onClick={() => onCloseModal?.()} type="primary">
        إغلاق
      </Button>
    </div>
  );
}

export default VideoView;
